import { transaction } from "./transaction.js";
// default variables
export const transactionsVars = {
    ids: undefined,
    from: undefined,
    to: undefined,
    tags: undefined,
    bundledIn: undefined,
    // block: undefined,
    minHeight: undefined,
    maxHeight: undefined,
    pageSize: 10,
    after: undefined,
    sort: "DESC", // REMAPPED
};
export const arweaveTransactionsQuery = {
    name: "transactions",
    query: transaction,
    enumValues: ["sort"],
    vars: transactionsVars,
    remapVars: {
        pageSize: "first",
        from: "owners",
        to: "recipients",
        // replace ASC/DESC to HEIGHT prefixed versions
        sort: (k, v) => [k, v === "ASC" ? "HEIGHT_ASC" : "HEIGHT_DESC"],
        minHeight: (_k, v, vars) => {
            vars.block = { ...vars.block, min: v };
            vars.minHeight = undefined;
        },
        maxHeight: (_k, v, vars) => {
            vars.block = { ...vars.block, max: v };
            vars.maxHeight = undefined;
        },
    },
    paging: {
        hasNextPage: "hasNextPage",
        cursor: "cursor",
    },
};
//# sourceMappingURL=transactions.js.map